import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface ProductSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function ProductSection({
  onBuyClick
}: ProductSectionProps) {
  return <section id="product-section" className="bg-[#FAF7F2] py-16 px-5" data-id="element-225">
      <div className="max-w-[900px] mx-auto" data-id="element-226">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-227">
          <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-228">
            <img src="https://cdn.magicpatterns.com/uploads/qZGEuuFcix5Fu8Cb8VPK1A/foto_website_1.png" alt="Your Baby's First Year — B.A.B.Y. 365 Protocol" className="w-full object-cover" data-id="element-229" />
          </div>

          <div data-id="element-230">
            <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-231">
              The Main Ebook
            </span>

            <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4" data-id="element-232">
              Your Baby's First Year:
              <br data-id="element-233" />
              Your Baby Needs You
            </h2>

            <p className="text-base text-[#6B4C3B] font-sans mb-6 leading-relaxed" data-id="element-234">
              A 60-page protocol based on applied neuroscience that integrates
              the 4 pillars of child development into a high-performance system.
              Designed for modern parents who value science, efficiency, and
              real results.
            </p>

            <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-235">
              {['📥 Immediate Download', '⭐ Premium Product', '📱 Mobile Compatible', '🌍 In English'].map((tag, idx) => <span key={idx} className="bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-xs px-3.5 py-1.5 rounded-full font-sans font-bold tracking-wide" data-id="element-236">
                  {tag}
                </span>)}
            </div>

            <a href={CHECKOUT_URL} onClick={onBuyClick} className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse max-w-md" data-id="element-237">
              ⚡ GET ACCESS NOW →
            </a>
          </div>
        </div>
      </div>
    </section>;
}